module.exports = __webpack_public_path__ + "img/zm_liucheng@3x.99cb580f.png";